import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getSupplierById } from "../../Dobavljaci/modules/actions";
import { getOfferById, updateOfferById } from "../modules/actions";
import { getCompanies } from "../../WebKalkulator/modules/actions";
import { getBrands } from "../../Brendovi/modules/actions";

const mapStateToProps = (state) => ({
  state: {
    loggedUser: state.user.loggedUser,
    supplier: state.suppliersReducer.supplierToEdit?.supplier,
    offerToEdit: state.offersReducer.offerToEdit,
    companies: state.clientsReducer.companies,
    brands: state.brandReducer.brands,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getSupplierById,
      getOfferById,
      updateOfferById,
      getCompanies,
      getBrands,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
